import safeLocalStorage from 'safe-localstorage';
import { SEARCH_TYPES } from 'src/services/constants';

export default () => {
  const historyString = safeLocalStorage.get('search/history');

  let history;
  if (historyString) {
    history = JSON.parse(historyString);
  }

  if (!Array.isArray(history)) {
    history = [];
  }

  return {
    filterTerms: '',
    history,
    mapPlacesSearchLoading: false,
    mapPlacesSearchResults: [],
    searchType: SEARCH_TYPES.KEYWORD,
    searchItems: [],
    selectedExternalAddressIndex: -1,
  };
};
